export default {
    back_login: '返回登录页',
    retrieve_title: '找回密码',
    retrieve_username: '邮箱/手机号',
    login_username: '请输入手机号/邮箱',
    retrieve_submit: '立即找回',
    login_account: '账号格式不正确！',
    reset_pwd: '重置密码',
    account_have_registration: '请使用该手机号注册新账号',
    go_register: '前往注册',
    reset_pwd_email_tip: '点击“发送邮件”，验证邮件将发送至注册邮箱{email}，请按照邮件提示，进行后续操作',
    password_reg: '密码必须是字母小写、数字、字母大写、特殊字符中任意两种组合，且不能少于8位！',
    send_email: '发送邮件',
    send_repeat: '再次发送',
    check_email: '查看邮件',
    send_email_success: '邮件发送成功',
    get_code_text: '获取验证码',
    s_reset_text: '{s}s后重发',
    reset_pwd_phone_tip: '点击获取验证码，短信将发送至注册手机{phone}',
    reset_pwd_reset_tip: '建议使用数字、字母、字符的组合密码，提高密码安全等级',
    original_password: '原始密码',
    new_password: '新密码',
    confrim_password: '确认密码',
    common_reg: '{name}不能为空',
    security_verification: '安全验证',
    required_null: '必填项不能为空',
    security_tip: '您可通过以下方式进行安全验证',
    security_type: '验证方式',
    email: '邮箱',
    phone: '手机号',
    select_pwd_type_title: '请选择修改密码方式',
    confirm_password_reg: '您两次输入的密码不一致！',
    online_pass_reset: '原密码修改',
    online_pass_tip: ' 输入「原密码」进行密码修改',
    online_pass_reset_email: '邮箱修改',
    online_pass_reset_email_tip: '通过登录「邮箱」进行密码修改',
    online_pass_reset_phone: '手机号修改',
    online_pass_reset_phone_tip: '输入「短信验证码」进行密码修改',
    captcha: '验证码',
    code_tips: '请输入手机验证码',
    please_enter: '请输入',
    login_mobile: '请输入手机号码',
    next: '下一步',
    save: '保存',
    prompt: '提示',
    determine: '确定',
    send_sms_success: '发送短信验证码成功',
    change_success: '修改成功',
    sms_reg: '短信验证',
    password: '设置密码',
    re_password: '确认密码',
    code_required: '请输入验证码',
    old_password: '请输入原密码',
    password_required: '密码不能为空',
    email_reg: '邮箱格式不正确',
    upload_file_reg: '请上传后缀为{format}的格式',
    select_num_reg: '选择的数量不能超过{num}条',
    account_have_reg: '当前输入的手机号码或邮箱已经存在，请使用该账号直接登录或找回密码！',
    account_have_Perfect: '该手机号码已经存在，是否给该用户绑定为持票人',
    change_pwd_by_pwd: '原密码方式',
    change_pwd_by_phone: '手机号方式',
    change_pwd_by_email: '通过邮箱方式',
    auth_reg: '身份验证',
    change_pwd: '修改密码',
    account_have_email_reg: '该邮箱已经存在，请使用该邮箱直接登录或找回密码！',
    account_no_register: '账号尚未注册，请先使用该{value}进行注册！',

    compellation: '姓名',
    p_compellation: '请输入姓名',
    professional: '职称',
    professional1: '正高',
    professional2: '副高',
    professional3: '中级',
    professional4: '初级',
    professional5: '其他',
    p_professional: '请选择职称',

    id_card: '本人身份证号',
    p_id_card: '请输入本人身份证号',
    bank_no: '本人银行卡号',
    p_bank_no: '请输入本人银行卡号',
    bank_branch_name: '开户支行名称',
    p_bank_branch_name: '请输入开户支行名称',
    hand_sign: '手写签名',
    please_sign: '请签名',
    id_card_err: '身份证号格式不正确',
    back_number: '开户银行卡号',
    p_back_number: '请输入开户银行卡号',
    bank_name: '开户银行名称',
    p_bank_name: '请选择开户行名称',
    back_user_name: '开户人姓名',
    p_back_user_name: '请输入开户人姓名',
    back_user_phone: '开户人手机号',
    p_back_user_phone: '请输入开户人手机号',
    back_user_company: '开户人单位名称',
    p_back_user_company: '请输入开户人单位名称',

    city: '所属城市',
    p_city: '请选择所属城市',
    province: '所属省市',
    p_province: '请选择所属省市',
    country: '所属国家',
    p_country: '请选择所属国家',
    perfect_info: '请完善信息',
    job: '现场工作岗位',
    p_job: '请选择现场工作岗位',
    identity: '工作人员身份',
    p_identity: '请选择工作人员身份',
    old_pwd: '原密码'
};
